export default {"src":"/_next/static/media/step2b.570b459b.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};